import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  UserRole,
  dynamic_urls,
  groupMenuValues,
  isTrivvyUrl,
  isTrivvyProduct,
  navigate_user_to_module,
} from '../../utils/constants'
import * as actionCreators from '../../modules/actions/index'
// import {NavBarLogo, Logo} from '../Logo/Logo';
import Logo from '../Logo/Logo'
import moment from 'moment'
import './NavBar.css'
import axios from '../../axios'
import { Link } from 'react-router-dom'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Progress,
} from 'reactstrap'
import Notifications from '../Notifications/Notifications'
import * as url from '../../utils/url'
import { withRouter } from 'react-router-dom'
import { isMobile } from '../../utils/deviceInfo'
import If from '../Shared/If'
import {
  BiArrowBack,
  BiHomeAlt,
  BiNotepad,
  BiSolidHomeAlt2,
} from 'react-icons/bi'
import { BsClipboardCheck, BsQuestionSquare } from 'react-icons/bs'

// import mixpanel from 'mixpanel-browser';
import { IoIosSettings } from 'react-icons/io'
import { HiChartSquareBar } from 'react-icons/hi'
import { IoOpenOutline } from 'react-icons/io5'
// Outline set per the Figma, replacing the raster privacy_icon.svg (three
// figures) and the flaticon bell/circled-chevron glyphs. Desktop header only.
import {
  LuChevronDown,
  LuUsers,
  LuBell,
  LuAlertCircle,
  LuMessageSquare,
  LuSettings,
  LuCreditCard,
} from 'react-icons/lu'

import { PiCalendarPlus } from 'react-icons/pi'
import { SiMinutemailer } from 'react-icons/si'
import { MdAssignment, MdHelp } from 'react-icons/md'
import { ImExit } from 'react-icons/im'
import { FaCircleUser } from 'react-icons/fa6'
import InviteAdminsTrivvy from '../../pages/office/InviteOfficeMates/InviteAdminsTrivvy'
import UpgradePlanModal from '../../pages/trivia/Components/UpgradePlanModal'
import ResponsePurchaseModal from '../../pages/trivia/Components/ResponsePurchaseModal'
import TrivvysWithWaitingResponsesModal from '../../pages/trivia/Components/TrivvysWithWaitingResponsesModal'
import ContactUsModal from './ContactUsModal'
import TriviaTemplatesModalMain from '../../pages/trivia/Components/CreateTrivia/TrivvyTemplatesModalMain'
import {
  getTrivvyCategory,
  getTrivvyListPath,
} from '../../pages/trivia/Components/backNav'
import TrivvyNavbarSearchComponent from './TrivvyNavbarSearchComponent'
import { minPlanLimitCheck } from '../../pages/trivia/data'
import { RiSurveyLine } from 'react-icons/ri'

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      path: [],
      backEnable: true,
      groupCategories: groupMenuValues,
      accordion: '',
      isOpen: false,
      dropdownOpenNavBar: false,
      notificationOpen: false,
      showMobileMenu: false,
      unreadNotificationsCount: 0,
      helpLink:
        'https://docs.google.com/document/d/1d3k6noDVUgAfKnd27h3bJBhUNGK37Kip65HLMumbWwU/edit?usp=sharing',
      purchaseResponsesModal: false,
      inviteAdminModal: false,
      upgradePlanModal: false,
      trivvyTemplateModalOpen: false,
      contactUsOpen: false,
      waitingResponsesModalOpen: false,
    }
  }

  componentDidMount() {
    this.setState({ path: this.props.location.pathname.split('/') })
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.state.path) !==
      JSON.stringify(nextProps.location.pathname.split('/'))
    ) {
      this.setState((prevState) => ({
        showMobileMenu: false,
        accordion: '',
      }))
      this.setState({ path: nextProps.location.pathname.split('/') })
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  handleLogout = () => {
    let { user } = this.props
    let { login_time, geo } = user
    let logout_time = moment()
    var duration = moment.duration(logout_time.diff(moment(login_time)))

    let payload = {
      login_time,
      logout_time,
      org_id: user.organizationId._id,
      org_name: user.organizationId.name,
      geo,
      duration: duration._data,
      miliseconds: duration._milliseconds,
    }
    this.props.onLogoutSuccess()
    this.props.history.push('/')

    axios
      .put(url.logoutUser, payload)
      .then(({ data }) => {
        console.log('LOGGED OUT')
        //  this.props.onLogoutSuccess();
        //  this.props.history.push('/');
      })
      .catch((error) => {
        this.props.onLogoutSuccess()
        this.props.history.push('/')
      })
  }

  showMobileMenu = () => {
    this.setState((prevState) => ({
      showMobileMenu: !prevState.showMobileMenu,
    }))
  }

  checkAxios = () => {
    // console.log("check axios")
    axios.interceptors.response.use(
      (res) => {
        return res
      },
      (error) => {
        // console.log('err--', error)

        if (401 === error.response.status) {
          // console.log('error----', error.response)
          // this.props.onUpdateUserSuccess("logout")
          // axios.put(url.logoutUser).then(({data}) => {
          //   this.props.onLogoutSuccess();
          //   this.props.history.push('/');
          //  }).catch(error => {
          //   this.props.onLogoutSuccess();
          //   this.props.history.push('/');
          //  })
          return Promise.reject(error)
        }
      }
    )

    // axios.interceptors.request.eject(axiosError);
  }

  getNotificationsCount = (pageNumber = 0) => {
    // Route is /notifications/:notification and the handler JSON.parses it
    // (notificationController.js:14). Same payload as Notifications.jsx:70.
    const payload = {
      pageNumber,
      isMobile,
      isTrivvy: isTrivvyProduct(),
    }
    axios
      .get(`${url.getNotifications}${JSON.stringify(payload)}`)
      .then((response) => {
        const { unread } = response.data.data
        this.props.updateNavBar({ unreadNotifications: unread })
      })
      .catch((error) => {
        // console.log(error);
      })
  }

  componentDidMount() {
    // console.log('hi---mobile', isMobile)
    // this.checkAxios()
    if (isMobile) this.getNotificationsCount()
  }

  toggleDD = () => {
    console.log('click o the navbar')
    this.setState({
      dropdownOpenNavBar: !this.state.dropdownOpenNavBar,
    })
  }

  navigateTo = (route) => {
    this.props.history.push(route)
  }

  toggleNotifications = () => {
    this.setState({
      notificationOpen: !this.state.notificationOpen,
      //  showMobileMenu:false
    })
  }

  handleUnreadCountChnaged = (unreadNotificationsCount) => {
    this.setState({ unreadNotificationsCount })
  }

  navigateToUploadData = () => {
    if (this.props.user.orgAdmin) {
      this.props.history.push('/home/upload-data')
    } else {
      this.props.history.push('/home/upload-data/manual')
    }
  }

  navigateToAllUsers = () => {
    this.props.history.push('/home/users')
  }

  renderOrgName = () => {
    let { user } = this.props
    let isLogoChange =
      this.props &&
      this.props.user &&
      user.organizationId.whiteLabel &&
      user.organizationId.whiteLabel.logo &&
      user.organizationId.whiteLabel.logo.url &&
      user.organizationId.whiteLabel.logo.url.length > 0
        ? true
        : false

    return (
      <span>
        {' '}
        {!isLogoChange
          ? isTrivvyUrl(user.organizationId)
            ? ''
            : 'at'
          : null}{' '}
        {user.organizationId.name}
      </span>
    )
  }

  openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer')
  }

  handleContactUs = () => {
    this.setState({
      contactUsOpen: true,
    })
    // let { user } = this.props;

    // window.open(`mailto:${isTrivvyUrl(user.organizationId)?"trivvy@ouroffice.io":"team@ouroffice.io"}`)
  }
  renderUserMenu = () => {
    // console.log(this.props)
    let {
      unreadNotificationsCount,
      isOpen,
      dropdownOpenNavBar,
      notificationOpen,
    } = this.state
    let { role, firstName, lastName, orgAdmin } = this.props.user
    let { isSignedUpFromTrivvyWebsite } = this.props.user.organizationId
    let isSetupSkipped = this.props.user.organizationId.isSetupSkipped
    let dashboardUrl = orgAdmin
      ? '/home/dashboard/overview'
      : '/home/dashboard/stories'

    let profileURL = dynamic_urls(
      this.props.user,
      this.props.user.organizationId
    ).my_profile
    let myEventsURL = dynamic_urls(
      this.props.user,
      this.props.user.organizationId
    ).my_events

    if (role) {
      return (
        <Dropdown
          isOpen={dropdownOpenNavBar}
          toggle={this.toggleDD}
          nav
          inNavbar>
          <DropdownToggle nav>
            <span className="nav-user-block">
              <span className="nav-user-avatar">
                {`${firstName || 'N'}`.charAt(0).toUpperCase()}
                {`${lastName || 'N'}`.charAt(0).toUpperCase()}
              </span>
              <span className="nav-user-name">{`${firstName} ${lastName}`}</span>
              <LuChevronDown className="nav-user-caret" size={18} />
            </span>
          </DropdownToggle>
          <DropdownMenu
            className="top-dd-bg"
            onClick={this.toggleDD}
            right
            style={{
              // backgroundColor: "#ffffff",
              // boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: '5px',
              padding: '0',
            }}>
            <div
              className="top-dd-option"
              onClick={() => this.navigateTo(profileURL)}>
              <span className="top-dd-option-icon">
                <FaCircleUser size={18} />
              </span>
              My Profile
            </div>

            {isTrivvyUrl(this.props.user.organizationId) ? (
              <div
                className="top-dd-option"
                onClick={() =>
                  this.navigateTo(
                    `/home/trivia/${this.props.user.organizationId._id}/list`
                  )
                }>
                <span className="top-dd-option-icon">
                  <BiSolidHomeAlt2 size={18} />
                </span>
                Home
              </div>
            ) : (
              ''
            )}

            {isTrivvyUrl(this.props.user.organizationId) ||
            (isSignedUpFromTrivvyWebsite &&
              isSignedUpFromTrivvyWebsite == true) ? null : (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo(myEventsURL)}>
                <span className="top-dd-option-icon">
                  <PiCalendarPlus size={18} />
                </span>
                My Events
              </div>
            )}

            {/* {isSetupSkipped?
                    orgAdmin?
                    <span></span>
                    :
                    null
                    :
                    <div className="top-dd-option" onClick={() => this.navigateTo('/home/office-info')}>Office Profile</div>
                    } */}

            {role === 'Admin' && (
              <div>
                {orgAdmin ? (
                  <div
                    className="top-dd-option"
                    onClick={() => this.navigateTo('/home/enterprise-info')}>
                    <span className="top-dd-option-icon">
                      <IoIosSettings size={18} />
                    </span>
                    Account Settings
                  </div>
                ) : null}


                {!isTrivvyUrl(this.props.user.organizationId) && (

                  
                  <div
                  className="top-dd-option"
                  onClick={() => this.navigateTo(dashboardUrl)}>
                  <span className="top-dd-option-icon">
                    <HiChartSquareBar size={18} />
                  </span>
                  Metrics{' '}
                </div>
                  )}

                {/* <div className="top-dd-option" onClick={() => this.navigateTo('/home/office/invite-office-mates')}> Invite Users </div> */}
              </div>
            )}

            {(!isSignedUpFromTrivvyWebsite || isSignedUpFromTrivvyWebsite) && (
              <div>
                {window.location.pathname.indexOf('/home/trivia') >= 0 ? (
                  <div
                    className="top-dd-option"
                    onClick={() =>
                      this.navigateTo(
                        navigate_user_to_module(
                          this.props.user.organizationId,
                          false
                        )
                      )
                    }>
                    <span className="top-dd-option-icon">
                      <BsQuestionSquare size={15} />
                    </span>
                    Go to OurOffice{' '}
                  </div>
                ) : (
                  <div
                    className="top-dd-option"
                    onClick={() =>
                      this.navigateTo(
                        dynamic_urls(
                          this.props.user,
                          this.props.user.organizationId
                        ).trivvy_dev
                      )
                    }>
                    <span className="top-dd-option-icon">
                      <BsQuestionSquare size={15} />
                    </span>
                    Go to Trivvy{' '}
                  </div>
                )}
              </div>
            )}

            {!isTrivvyUrl(this.props.user.organizationId) && (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/users/invite')}>
                <span className="top-dd-option-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16">
                    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                    <path
                      fillRule="evenodd"
                      d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                    />
                  </svg>
                </span>
                Invite Users{' '}
              </div>
            )}

            <div
              className="top-dd-option"
              onClick={() => this.handleContactUs()}>
              <span className="top-dd-option-icon">
                <SiMinutemailer size={18} />
              </span>
              <span className="contact-us cursor-pointer">Contact Us</span>
            </div>

            {/* <div className="top-dd-option"><a className="contact-us" target="_blank" href={this.state.helpLink}>Help</a></div> */}

            {!isTrivvyUrl(this.props.user.organizationId) && (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/help')}>
                <span className="top-dd-option-icon">
                  <MdHelp size={18} />
                </span>
                Help
              </div>
            )}

            {/* {!isTrivvyUrl(this.props.user.organizationId) && (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/terms')}>
                <span className="top-dd-option-icon">
                  <MdAssignment size={18} />
                </span>
                Terms
              </div>
            )} */}

              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/terms')}>
                <span className="top-dd-option-icon">
                  <MdAssignment size={18} />
                </span>
                Terms
              </div>

            <div className="top-dd-option" onClick={() => this.handleLogout()}>
              <span className="top-dd-option-icon">
                <ImExit size={18} />
              </span>
              Sign Out
            </div>
          </DropdownMenu>
        </Dropdown>
      )
    } else {
      return (
        <Dropdown
          isOpen={dropdownOpenNavBar}
          toggle={this.toggleDD}
          nav
          inNavbar>
          <DropdownToggle nav>
            <span className="nav-user-block">
              <span className="nav-user-avatar">
                {`${firstName || 'N'}`.charAt(0).toUpperCase()}
                {`${lastName || 'N'}`.charAt(0).toUpperCase()}
              </span>
              <span className="nav-user-name">{`${firstName} ${lastName}`}</span>
              <LuChevronDown className="nav-user-caret" size={18} />
            </span>
          </DropdownToggle>
          <DropdownMenu
            className="top-dd-bg"
            onClick={this.toggleDD}
            right
            style={{
              // backgroundColor: "#969696",
              // boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: '5px',
              padding: '0',
            }}>
            <div
              className="top-dd-option"
              onClick={() => this.navigateTo(profileURL)}>
              <span className="top-dd-option-icon">
                <FaCircleUser size={18} />
              </span>
              My Profile
            </div>

            {isTrivvyUrl(this.props.user.organizationId) ? (
              <div
                className="top-dd-option"
                onClick={() =>
                  this.navigateTo(
                    `/home/trivia/${this.props.user.organizationId._id}/list`
                  )
                }>
                <span className="top-dd-option-icon">
                  <BiSolidHomeAlt2 size={18} />
                </span>
                Home
              </div>
            ) : (
              ''
            )}

            {isSignedUpFromTrivvyWebsite &&
            isSignedUpFromTrivvyWebsite == true ? null : (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo(myEventsURL)}>
                <span className="top-dd-option-icon">
                  <PiCalendarPlus size={18} />
                </span>
                My Events
              </div>
            )}

            {/* <div className="top-dd-option" onClick={() => this.navigateTo('/home/users')}>Users</div>      */}

            <div
              className="top-dd-option"
              onClick={() => this.handleContactUs()}>
              <span className="top-dd-option-icon">
                <PiCalendarPlus size={18} />
              </span>
              My Events
            </div>
            {/* <div className="top-dd-option" onClick={() => this.navigateTo('/home/users')}>Users</div>      */}
            <div className="top-dd-option">
              <span className="top-dd-option-icon">
                {/* <RiSurveyLine size={18} /> */}
                <IoOpenOutline size={18} />
              </span>
              <a
                className="contact-us"
                target="_blank"
                href="https://trivvy.ouroffice.io">
                Go to Trivvy
              </a>
            </div>
            <div className="top-dd-option">
              <span className="top-dd-option-icon">
                <SiMinutemailer size={18} />
              </span>
              <span className="contact-us">Contact Us</span>
            </div>

            {!isTrivvyUrl(this.props.user.organizationId) && (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/help')}>
                <span className="top-dd-option-icon">
                  <MdHelp size={18} />
                </span>
                Help
              </div>
            )}

            {/* {!isTrivvyUrl(this.props.user.organizationId) && (
              <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/terms')}>
                <span className="top-dd-option-icon">
                  <MdAssignment size={18} />
                </span>
                Terms
              </div>
            )} */}
             <div
                className="top-dd-option"
                onClick={() => this.navigateTo('/home/terms')}>
                <span className="top-dd-option-icon">
                  <MdAssignment size={18} />
                </span>
                Terms
              </div>


            <div className="top-dd-option" onClick={() => this.handleLogout()}>
              <span className="top-dd-option-icon">
                <ImExit size={18} />
              </span>
              Sign Out
            </div>
          </DropdownMenu>
        </Dropdown>
      )
    }
  }

  createMarkup(html) {
    return { __html: `<div>${html}</div>` }
  }

  goBack() {
    const { backTo } = this.props.navBar
    backTo ? this.props.history.push(backTo) : this.props.history.goBack()
    this.setState((prevState) => ({
      showMobileMenu: !prevState.showMobileMenu,
    }))
  }

  toMobileNotifications = () => {
    this.setState((prevState) => ({
      showMobileMenu: false,
    }))
    this.props.history.push('/home/notifications')
  }

  go2MobilePage = (value) => {
    // console.log("annoucne!!")
    this.setState((prevState) => ({
      showMobileMenu: false,
    }))

    if (value == 'announcement') {
      this.props.history.push(`/home/announcements`)
    } else if (value === 'planning') {
      this.props.history.push('/home/my-activity')
    } else if (value === 'trivia') {
      this.props.history.push(
        `/home/trivia/${this.props.user.organizationId._id}/list`
      )
    } else if (value == 'cultureApp') {
      this.props.history.push('/home/stories')
    } else {
      this.props.history.push(`/home/stories`)
    }
  }

  goToGroups = (val) => {
    let url
    // console.log('val---', val)
    if (val == 1) {
      url =
        this.props.match.url +
        '/groups/' +
        this.props.user.organizationId._id +
        '/discover'
      this.props.history.push(url)
      this.setState((prevState) => ({
        showMobileMenu: false,
      }))
    } else if (val == 0) {
      url =
        this.props.match.url +
        '/groups/' +
        this.props.user.organizationId._id +
        '/feed'
      this.props.history.push(url)
      this.setState((prevState) => ({
        showMobileMenu: false,
      }))
    } else if (val == 2) {
      const { accordion } = this.state
      this.setState({ accordion: accordion !== 'g' ? 'g' : '' })
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (isMobile && this.props.location.pathname !== prevProps.location.pathname) {
  //     window.scrollTo(0, 0);
  //   } else if(!isMobile && this.props.location.pathname !== prevProps.location.pathname){
  //     let isStories = this.props && this.props.location && this.props.location.pathname.indexOf("/home/stories")>-1?true:false
  //     this.setState({isStories})
  //   }

  // }

  detailsPageBackHandle = () => {
    if (this.props.navBar.backButtonData.currentPageType === 'STORY_DETAILS') {
      this.props.history.go(-2)
    } else {
      this.props.history.go(-1)
    }
  }

  backButtonRender = () => {
    if (this.props.navBar) {
      if (this.props.navBar.backButtonData.show) {
        return (
          <Button
            color="light"
            className="ml-3 bg-transparent"
            onClick={this.detailsPageBackHandle}
            style={{ whiteSpace: 'nowrap' }}>
            <BiArrowBack className="mr-1" /> Back
          </Button>
        )
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  addTrivvySuccessFromTemplates = (data) => {
    if (this.props.setImportTemplateAddedTrivvys) {
      this.props.setImportTemplateAddedTrivvys(data)
      this.setState({
        trivvyTemplateModalOpen: false,
      })
    }
  }

  renderTrivvySettings = () => {
    const {
      uploadUsersModal,
      purchaseResponsesModal,
      inviteAdminModal,
      upgradePlanModal,
      trivvyTemplateModalOpen,
    } = this.state
    const orgObject = this.props.user.organizationId

    const totalAllowed = orgObject.totalTriviaResponsesCount
    const totalSubmitted = orgObject.submittedTriviaResponsesCount

    const trivvyPlanType = orgObject.trivvyPlanType

    const percent = (totalSubmitted / totalAllowed) * 100

    let smsPercent = null

    if (minPlanLimitCheck(trivvyPlanType, '002') && orgObject.smsLimit) {
      smsPercent = Math.round(
        (orgObject.totalSmsSent / orgObject.smsLimit) * 100
      )
    }
    return (
      <div
        className={`mt-1 px-3 ${isMobile ? 'text-right' : 'py-3'}`}
        id="trivia_ui_responses_counter">
        <div>
          <div className="gray-text-sm">
            {' '}
            <LuAlertCircle size={14} className="mr-1" /> Responses collected
          </div>
          <div>
            {!isMobile && <Progress value={percent} />}
            {isMobile ? (
              <div>
                <span className="gray-text-sm"> {totalSubmitted} </span>{' '}
              </div>
            ) : (
              <div>
                {' '}
                <span>{totalSubmitted} / </span>{' '}
                <span className="gray-text-sm"> {totalAllowed} </span>
              </div>
            )}
            <div></div>
          </div>
        </div>

        {smsPercent != null && (
          <div className="my-2">
            <div className="gray-text-sm">
              {' '}
              <LuMessageSquare className="mr-1" />
              SMS Texts{' '}
              {minPlanLimitCheck(orgObject.trivvyPlanType, '003')
                ? 'Included'
                : ''}
            </div>
            {minPlanLimitCheck(orgObject.trivvyPlanType, '003') ? (
              ''
            ) : (
              <span>
                <Progress value={smsPercent} />
                {orgObject.totalSmsSent} /{' '}
                <span className="gray-text-sm"> {orgObject.smsLimit} </span>
                {/* {this.props.user.orgAdmin && orgObject.trivvyPlanType ? (
                  // orgObject.trivvyPlanType != "001"

                    <span
                      className="trivvy-sidebar-add-user-seat font-11px"
                      onClick={() => {
                        this.setState({ inviteAdminModal: true });
                      }}
                    >
                      (Manage Plan)
                    </span>

                ) : (
                  ""
                )} */}
              </span>
            )}
          </div>
        )}
        {/* Take-both: QA's button + modal keep the behaviour; the pill class and
            icon give it the Figma look, and the pill supplies its own margin. */}
        {orgObject.waitingTriviaResponsesCount > 0 && (
          <div>
            <button
              type="button"
              className="waiting_responses_btn trivvy-color sidebar-waiting-pill"
              onClick={() => this.setState({ waitingResponsesModalOpen: true })}
            >
              <LuAlertCircle />{' '}
              {orgObject.waitingTriviaResponsesCount} responses waiting
            </button>
          </div>
        )}
        {this.state.waitingResponsesModalOpen && (
          <TrivvysWithWaitingResponsesModal
            isOpen={this.state.waitingResponsesModalOpen}
            toggle={() =>
              this.setState({
                waitingResponsesModalOpen: !this.state.waitingResponsesModalOpen,
              })
            }
          />
        )}
        {purchaseResponsesModal && (
          <ResponsePurchaseModal
            open={purchaseResponsesModal}
            orgChangeSuccess={this.props.orgChangeSuccess}
            onClose={() => {
              this.setState({
                purchaseResponsesModal: false,
              })
            }}
            showResponseTable={minPlanLimitCheck(
              orgObject.trivvyPlanType,
              '002'
            )}
          />
        )}

        <div
          className="mt-3 cursor-pointer trivvy-sidebar-mng-resp"
          onClick={() => this.setState({ purchaseResponsesModal: true })}
          // style={{
          //   display:"flex",
          //   gap:"3px"
          // }}
        >
          <LuSettings className="" /> Increase response limit
        </div>

        {this.props.user.orgAdmin && orgObject.trivvyPlanType ? (
          // orgObject.trivvyPlanType != "001"
          <div className="mt-3">
            <a
              className="trivvy-sidebar-add-user-seat"
              onClick={() => {
                this.setState({ inviteAdminModal: true })
              }}>
              <LuCreditCard className="" /> Manage Plan and User Seats
            </a>
          </div>
        ) : (
          ''
        )}

        {upgradePlanModal && (
          <UpgradePlanModal
            open={upgradePlanModal}
            onClose={() => this.setState({ upgradePlanModal: false })}
          />
        )}

        {inviteAdminModal && (
          <InviteAdminsTrivvy
            open={inviteAdminModal}
            onClose={() => this.setState({ inviteAdminModal: false })}
            history={this.props.history}
          />
        )}

        {trivvyTemplateModalOpen && (
          <TriviaTemplatesModalMain
            open={trivvyTemplateModalOpen}
            onClose={() => this.setState({ trivvyTemplateModalOpen: false })}
            addTrivvySuccessFromTemplates={this.addTrivvySuccessFromTemplates}
          />
        )}

        {/* <Button
          className="trivia-action-button-main trivv-create-btn mt-3 mb-2"
          onClick={() => {
            this.setState({
              trivvyTemplateModalOpen: true,
            });
          }}
          // color="success"
          size="sm"
        >
          <BiNotepad /> Trivvy Templates
        </Button> */}
      </div>
    )
  }

  trivvyMobileBackButtonCheck = () => {
    const pathname = this.props.location.pathname

    if (
      pathname.indexOf('/my-trivia') >= 0 ||
      pathname.indexOf('/rewards') >= 0 ||
      pathname.indexOf('/library') >= 0 ||
      pathname.indexOf('/edit') >= 0 ||
      pathname.indexOf('/notifications') >= 0 ||
      pathname.indexOf('/enterprise-info') >= 0 ||
      pathname.indexOf('/profile/') >= 0
    ) {
      return true
    } else {
      return false
    }
  }

  goToTrivvyList = () => {
    // On a doc's edit page, go where the top-left crumb goes (its own list/folder).
    const { currentTriviaId, currentTriviaListPath } = this.props
    const editMatch = this.props.location.pathname.match(/\/edit\/([^/]+)/)
    if (
      editMatch &&
      currentTriviaListPath &&
      String(currentTriviaId) === editMatch[1]
    ) {
      this.props.history.push(currentTriviaListPath)
      return
    }
    this.props.history.push(
      `/home/trivia/${this.props.user.organizationId._id}/list`
    )
  }

  render() {
    const {
      unreadNotificationsCount,
      isOpen,
      dropdownOpenNavBar,
      notificationOpen,
      showMobileMenu,
      path,
    } = this.state
    let {
      role,
      firstName,
      lastName,
      orgAdmin,
      organizationId,
    } = this.props.user
    let isSetupSkipped = this.props.user.organizationId.isSetupSkipped
    const {
      hasBack,
      showNotification,
      backButton,
      title,
      unreadNotifications,
      isBreadCrumbs,
      className,
    } = this.props.navBar
    // console.log(this.props.navBar)

    const unread = unreadNotificationsCount || unreadNotifications
    let home_url = ''

    if (organizationId.selectModule) {
      if (organizationId.isCultureApp && organizationId.isCultureApp.status) {
        home_url = '/home/stories'
      }
    } else {
      home_url = '/home/stories'
    }

    if (
      organizationId.isSignedUpFromTrivvyWebsite ||
      isTrivvyUrl(organizationId)
    ) {
      home_url = `/home/trivia/${organizationId._id}/list`
    }

    const brandLogo = (
      <NavbarBrand
        onClick={
          home_url && home_url.length > 0
            ? () => this.props.history.push(home_url)
            : null
        }
        className={
          home_url && home_url.length > 0
            ? `d-flex align-items-center cursor-pointer`
            : `d-flex align-items-center`
        }>
        <Logo />
        <span
          style={{
            marginLeft: '1em',
            color: '#333333',
            fontSize: '16px',
            marginTop: '24px',
            marginBottom: '20px',
            lineHeight: '22px',
          }}>
          {!isMobile && this.renderOrgName()}
        </span>
      </NavbarBrand>
    )

    let profileURL = dynamic_urls(
      this.props.user,
      this.props.user.organizationId
    ).my_profile

    const isTrivvyOrg =
      this.props.user && this.props.user.organizationId
        ? this.props.user.organizationId.isSignedUpFromTrivvyWebsite ||
          this.props.user.organizationId.trivvyPlanType
        : false
    return (
      <Navbar
        expand="md"
        fixed="top"
        role="navigation"
        className={
          isMobile
            ? `top-navbar-bg ${className} noMobileNavbarPadding`
            : `top-navbar-bg ${className} bwai-chrome-nav`
        }
        style={{
          borderTopColor:
            this.props.user.organizationId.whiteLabel &&
            this.props.user.organizationId.whiteLabel.brandColor
              ? this.props.user.organizationId.whiteLabel.brandColor
              : '#ff4500',
        }}>
        <If condition={isMobile}>
          <div className={`container navbar-header mobileNavbarPadding`}>
            <If condition={isBreadCrumbs}>
              <div className="navbar-breadcrumbs col-10 plpr-0">
                <div
                  className="navbar-back pr-2"
                  onClick={this.goBack.bind(this)}
                  dangerouslySetInnerHTML={this.createMarkup(backButton)}></div>
                <span className="navbar-arrow">
                  {' '}
                  <i className="chart-item-menu flaticon-down"></i>{' '}
                </span>
                <div
                  className="pl-1 navbar-content"
                  dangerouslySetInnerHTML={this.createMarkup(title)}></div>
              </div>
            </If>
            <If condition={hasBack && !isBreadCrumbs}>
              {!isBreadCrumbs &&
              isTrivvyUrl(this.props.user.organizationId) &&
              this.trivvyMobileBackButtonCheck() ? (
                <div
                  className="col-1 px-0 text-center cursor-pointer vertical-middle"
                  style={{
                    marginLeft: '-10px',
                  }}>
                  <BiArrowBack onClick={this.goToTrivvyList} size={17} />
                </div>
              ) : (
                ''
              )}
              {/* <div className="col-2 navbar-back vertical-middle" onClick={this.goBack.bind(this)} dangerouslySetInnerHTML={this.createMarkup(backButton)}></div> */}
              <div
                className={`col-2 ${
                  isTrivvyUrl(this.props.user.organizationId) ? 'pl-0' : ''
                }`}>
                <If condition={showNotification}>
                  <NavLink
                    className="alarm-section cursor-pointer"
                    style={{ position: 'relative' }}>
                    <span
                      id="notification-popover"
                      style={{ position: 'relative' }}
                      onClick={() => this.toMobileNotifications()}>
                      {/* Matches desktop. `color` prop, not .nav-icon-glyph:
                          bwai-chrome-nav is desktop-only, so the class won't style it. */}
                      <LuBell size={20} strokeWidth={1.75} color="#0f172a" />
                      {/* Inside this positioned span, as on desktop: the badge
                          offsets measure from the bell, not the whole NavLink. */}
                      {unread > 0 && (
                        <span
                          style={{
                            background:
                              this.props.user.organizationId.whiteLabel &&
                              this.props.user.organizationId.whiteLabel
                                .brandColor
                                ? this.props.user.organizationId.whiteLabel
                                    .brandColor
                                : '',
                          }}
                          className="unread-count bwai-chrome-badge">
                          {unread > 99 ? (
                            <span className="more-unread">99+</span>
                          ) : (
                            unread
                          )}
                        </span>
                      )}
                    </span>
                  </NavLink>
                </If>
              </div>

              <If condition={title}>
                {isTrivvyUrl(this.props.user.organizationId) ? (
                  <div
                    className="col-8 text-center vertical-middle"
                    // dangerouslySetInnerHTML={this.createMarkup(title)}
                  >
                    {this.props.user.organizationId.name}
                  </div>
                ) : (
                  <div
                    className="col-9 text-center vertical-middle"
                    dangerouslySetInnerHTML={this.createMarkup(title)}></div>
                )}
              </If>
            </If>
            <If condition={!hasBack}>
              <div
                style={{
                  ...(isTrivvyUrl(this.props.user.organizationId) && {
                    display: 'flex',
                    alignItems: 'center',
                  }),
                }}>
                {' '}
                {isTrivvyUrl(this.props.user.organizationId) &&
                this.trivvyMobileBackButtonCheck() ? (
                  <span
                    className="cursor-pointer "
                    style={{
                      marginLeft: '-10px',
                    }}>
                    <BiArrowBack onClick={this.goToTrivvyList} size={17} />
                  </span>
                ) : (
                  ''
                )}{' '}
                {brandLogo}
              </div>
            </If>

            {/* <div className="col-2">
              <If condition={showNotification}>
              <NavLink className="alarm-section cursor-pointer" style={{position: 'relative'}}>
                {unread > 0 && <span className="unread-count bwai-chrome-badge">{unread>99 ? (<span className="more-unread">99+</span>): unread}</span>}
                <span id="notification-popover" style={{position: 'relative'}} onClick={() => this.props.history.push('/home/notifications')}>
                  <i className="flaticon-alarm"></i>
                </span>
              </NavLink>
              </If>

            </div> */}

            <div
              className="col-1 navbar-back vertical-middle"
              onClick={() => this.showMobileMenu()}>
              {/* Menu */}
              <i
                className="chart-item-menu flaticon-menu-1"
                style={{ cursor: 'pointer' }}></i>
            </div>
          </div>

          <Dropdown
            isOpen={showMobileMenu}
            toggle={() => this.showMobileMenu}
            className="mobileMenuDD bwai-chrome-mobile-menu">
            <DropdownToggle
              tag="span"
              className="chart-item-menu"
              onClick={() => this.showMobileMenu()}
              data-toggle="dropdown"
              aria-expanded={showMobileMenu}>
              {/* <i className="chart-item-menu flaticon-menu-1" style={{ cursor: 'pointer' }}></i> */}
            </DropdownToggle>

            {organizationId.isSignedUpFromTrivvyWebsite || isTrivvyProduct() ? (
              <DropdownMenu
                right
                className="mobileMenuDDcontainer"
                style={{ padding: '0' }}>
                <div
                  className="mobileMenuText"
                  onClick={() =>
                    this.navigateTo(
                      dynamic_urls(
                        this.props.user,
                        this.props.user.organizationId
                      ).trivvy_dev
                    )
                  }
                  // onClick={() => this.go2MobilePage("home")}
                >
                  Trivvy
                </div>

                <div
                  className="mobileMenuText"
                  onClick={() => this.navigateTo(profileURL)}
                  // onClick={() => this.go2MobilePage("home")}
                >
                  My Profile
                </div>

                {orgAdmin ? (
                  <div
                    className="mobileMenuText"
                    onClick={() => this.navigateTo('/home/enterprise-info')}>
                    Account Settings
                  </div>
                ) : null}
                <div
                  className="mobileMenuText"
                  onClick={() => this.props.history.push(`/home/users`)}
                  // onClick={() => this.go2MobilePage("home")}
                >
                  Users
                </div>

                {this.props.user.role == 'Admin' && (
                  <div className="mobileMenyText">
                    <div>{this.renderTrivvySettings()}</div>
                  </div>
                )}

                <div
                  className="mobileMenuText"
                  onClick={() => this.navigateTo('/home/terms')}>
                  <span className="mr-2">
                    <MdAssignment size={18} />
                  </span>
                  Terms
                </div>

                <div
                  className="mobileMenuText"
                  onClick={() => this.handleContactUs()}>
                  Contact Us
                </div>

                <div
                  className="mobileMenuText"
                  onClick={() => this.handleLogout()}>
                  Sign Out
                </div>
              </DropdownMenu>
            ) : (
              <DropdownMenu
                right
                className="mobileMenuDDcontainer"
                style={{ padding: '0' }}>
                <div
                  className="mobileMenuText"
                  onClick={() => this.go2MobilePage('home')}>
                  Home
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() =>
                    this.navigateTo(
                      dynamic_urls(
                        this.props.user,
                        this.props.user.organizationId
                      ).trivvy_dev
                    )
                  }>
                  Trivvy
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() => this.go2MobilePage('announcement')}>
                  {' '}
                  Announcement{' '}
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() => this.props.history.push(`/home/users`)}
                  // onClick={() => this.go2MobilePage("home")}
                >
                  Users
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() => this.go2MobilePage('planning')}>
                  Planning
                </div>
                <div
                  className={
                    this.state.accordion === 'g'
                      ? 'mobileMenuText active'
                      : 'mobileMenuText'
                  }
                  style={{
                    fontWeight: this.state.accordion == 'g' ? '600' : 'normal',
                  }}
                  onClick={() => this.goToGroups(2)}>
                  Groups
                </div>
                <Collapse
                  isOpen={this.state.accordion == 'g'}
                  style={{ paddingBottom: '0px', marginTop: '-10px' }}>
                  <Nav vertical className="category-wrapper-mobile">
                    {this.state.groupCategories.map((category, i) => {
                      return (
                        <NavItem key={i} className="nav-item text-md mt10">
                          <span className="sidebar-category">
                            <Link
                              to={
                                this.props.match.url +
                                '/groups/' +
                                this.props.user.organizationId._id +
                                '/' +
                                category.link
                              }
                              className={
                                path.includes('groups') &&
                                path.includes(category.link)
                                  ? 'category-active'
                                  : 'category'
                              }>
                              {category.name}
                            </Link>
                          </span>
                        </NavItem>
                      )
                    })}
                    {!isTrivvyProduct() ? (
                      <NavItem className="nav-item text-md mt10">
                        <span className="sidebar-category">
                          <Link
                            to={this.props.match.url + '/groups/' + 'metrics'}
                            className={
                              path.includes('groups') &&
                              path.includes('/metrics')
                                ? 'category-active'
                                : 'category'
                            }>
                            Metrics
                          </Link>
                        </span>
                      </NavItem>
                    ) : null}
                  </Nav>
                </Collapse>
                <div
                  className="mobileMenuText"
                  onClick={this.goBack.bind(this)}>
                  {' '}
                  Back{' '}
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() => this.handleContactUs()}>
                  Contact Us
                </div>
                <div
                  className="mobileMenuText"
                  onClick={() => this.handleLogout()}>
                  Sign Out
                </div>
              </DropdownMenu>
            )}
          </Dropdown>
        </If>

        <If condition={!isMobile}>
          {brandLogo}

          {this.backButtonRender()}

          {isTrivvyUrl(this.props.user.organizationId) ? (
            <div
              className="ml-4 TrivvyNavbarSearchComponent"
              style={{ width: '50%', padding: '0 15px' }}>
              <TrivvyNavbarSearchComponent {...this.props} />
            </div>
          ) : null}

          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="ml-auto" style={{ height: '62px' }} navbar>
              {!isTrivvyUrl(this.props.user.organizationId) &&
                role !== UserRole.user &&
                role !== 'Member' &&
                !isSetupSkipped && (
                  <NavItem>
                    <NavLink
                      className="upload-section cursor-pointer"
                      onClick={this.navigateToUploadData}>
                      <i className="flaticon-upload"></i>
                    </NavLink>
                  </NavItem>
                )}

              <NavItem>
                <NavLink
                  className="navbarUsersIcon cursor-pointer"
                  onClick={this.navigateToAllUsers}>
                  {/* <i className="flaticon-upload"></i> */}
                  {!isMobile && (
                    <LuUsers
                      className="nav-icon-glyph"
                      size={20}
                      strokeWidth={1.75}
                    />
                  )}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className="alarm-section cursor-pointer"
                  style={{ position: 'relative' }}>
                  <span
                    id="notification-popover"
                    style={{ position: 'relative' }}
                    onClick={this.toggleNotifications}>
                    <LuBell className="nav-icon-glyph" size={20} strokeWidth={1.75} />
                    {unreadNotificationsCount > 0 && (
                      <span
                        style={{
                          background:
                            this.props.user.organizationId.whiteLabel &&
                            this.props.user.organizationId.whiteLabel.brandColor
                              ? this.props.user.organizationId.whiteLabel
                                  .brandColor
                              : '',
                        }}
                        className="unread-count bwai-chrome-badge">
                        {unreadNotificationsCount > 99
                          ? '99+'
                          : unreadNotificationsCount}
                      </span>
                    )}
                  </span>
                  <Notifications
                    {...this.props}
                    notificationOpen={notificationOpen}
                    toggle={this.toggleNotifications}
                    onUnreadCountChanged={this.handleUnreadCountChnaged}
                  />
                </NavLink>
              </NavItem>
              <div>
                <div className="name-section d-flex justify-content-end align-items-center">
                  {this.renderUserMenu()}
                </div>
              </div>
            </Nav>
          </Collapse>
        </If>

        {this.props.user && this.state.contactUsOpen && (
          <ContactUsModal
            open={this.state.contactUsOpen}
            onClose={() => this.setState({ contactUsOpen: false })}
            user={this.props.user}
          />
        )}
      </Navbar>
    )
  }
}

const mapStateToProps = (state) => {
  // Primitives only, so typing in the editor (currentTrivia churn) never re-renders NavBar.
  const profile = state.user.profile
  const orgId = profile && profile.organizationId && profile.organizationId._id
  const trivvy = state.trivia.currentTrivia
  let listPath = null
  if (trivvy && getTrivvyCategory(trivvy) !== 'REWARD') {
    listPath = getTrivvyListPath(orgId, trivvy)
  }
  return {
    navBar: state.navBar,
    user: state.user.profile,
    currentTriviaId: trivvy ? trivvy._id : null,
    currentTriviaListPath: listPath,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogoutSuccess: (data) => dispatch(actionCreators.logout()),
    onUpdateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar))
